<template>
  <div>
    <v-checkbox
      @change="handleInput"
      :class="{ checkbox__bordered: bordered }"
      :label="label"
      :value="value"
      :input-value="inputValue"
      :color="color"
      hide-details
      outlined
      dense
    />
  </div>
</template>

<script>
export default {
  name: 'HCheckbox',

  props: {
    label: {
      type: String,
      required: false,
    },

    color: {
      type: String,
      default: '',
    },

    value: {
      type: Boolean,
    },

    inputValue: {
      type: Boolean,
    },

    bordered: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleInput(value) {
      this.$emit('input', !!value)
    },
  },
}
</script>
